import React from 'react';
import{createRoot}from'react-dom/client';
import{QueryClientProvider}from'@tanstack/react-query';
import{queryClient}from'./wheel/lib/queryClient';
import{SiteSettingsProvider}from'./wheel/contexts/SiteSettingsContext';
import{AuthProvider,useAuth}from'./wheel/contexts/AuthContext';
import{ToastProvider}from'./wheel/components/Toast';
import{SpinWheelProvider}from'./wheel/contexts/SpinWheelContext';
import MemberApp from './member/MemberApp';
import './styles/extra.css';
import './styles/coupons.css';
import './styles/brand-fonts.css';
import './styles/market.css';
function MemberScope(){const{revision}=useAuth();return<SpinWheelProvider key={revision}><MemberApp/></SpinWheelProvider>;}
createRoot(document.getElementById('root')!).render(<React.StrictMode><QueryClientProvider client={queryClient}><SiteSettingsProvider><AuthProvider><ToastProvider><MemberScope/></ToastProvider></AuthProvider></SiteSettingsProvider></QueryClientProvider></React.StrictMode>);
